import React, { Component } from "react";
import { connect } from "react-redux";
import Layout from "../../components/layout/layout";
import skullIcon from "../../static/skull.svg";
import BannerLogo from "../../components/logo/logo";
import closeDarkIcon from "../../static/close.svg";
import "./not-found.scss";
import Util from "../../utils/util";

class NotFound extends Component {
  componentDidMount() {
    if (window.location.pathname.indexOf("store-not-active") <= -1) {
      dataLayer.push({
        'event': 'dataLayer-initialized',
        'customAttributes':Util.getCustomAttributes(),
        'userID': Util.getEmailId(),
        'language': Util.getSelectedLanguage(),
        'pageName': 'store not active',
        'pageType': 'error',
        'storeID': '',
        'storeDesc': ''
      });
    } else {
      dataLayer.push({
        'event': 'dataLayer-initialized',
        'customAttributes':Util.getCustomAttributes(),
        'userID': Util.getEmailId(),
        'language': Util.getSelectedLanguage(),
        'pageName': 'not found',
        'pageType': 'error',
        'storeID': '',
        'storeDesc': ''
      });
    }
  }
  onManualPopupClose() {
    const storeDetail = Util.getStoreDetails();
    if (storeDetail && storeDetail.storeId) {
      window.location.href = "/cart";
    } else {
      window.location.href = "/";
    }
  }
  render() {
    let errorCopyText = {};
    let common = {};
    if (this.props.locale && this.props.locale.screens) {
      errorCopyText = this.props.locale.screens.error;
      common = this.props.locale.screens.common;
    }
    
    return (
        <div className="common-error-screen-container">
          <img
            alt=""
            src={closeDarkIcon}
            className="close-icon"
            onClick={this.onManualPopupClose}
          />
          <BannerLogo className="coach-logo" commonTextData={common} />
          <h2 className="first">{errorCopyText.sorry}</h2>
          <h2>{errorCopyText.commonErrorHead}</h2>
          <img alt="" src={skullIcon} className="error-image" />
          <label className="first">{errorCopyText.commonErrorText1}</label>
          <label className="last">{errorCopyText.commonErrorText2}</label>
          <div className="bottom-text">
            <span>{errorCopyText.stillHavingIssue}</span>
            <span>{errorCopyText.seeStoreAssoiciate}</span>
          </div>
        </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    locale: state.locale
  };
};

const mapDispatchToProps = dispatch => {
  return {

  };
};

const connectedNotFound = connect(
  mapStateToProps,
  mapDispatchToProps
)(NotFound);

export default connectedNotFound;
